var Idioma = /* @__PURE__ */ ((Idioma2) => {
  Idioma2["PT_BR"] = "PT_BR";
  Idioma2["EN"] = "EN";
  Idioma2["ES"] = "ES";
  return Idioma2;
})(Idioma || {});
const IdiomaInfo = {
  ["PT_BR" /* PT_BR */]: {
    language: "pt-br",
    icon: "brazil"
  },
  ["EN" /* EN */]: {
    language: "en",
    icon: "united-states"
  },
  ["ES" /* ES */]: {
    language: "es",
    icon: "spain"
  }
};

export { Idioma, IdiomaInfo };
